/**
 * useDocumentDatabases Hook
 *
 * Custom React Query hook for fetching document databases list.
 */

import { useQuery } from '@tanstack/react-query';
import { documentDatabaseService } from '../../../api/document-database.service';
import type { DocumentDatabaseListQuery } from '../../../types/document-database.types';

/**
 * Hook for fetching document databases
 * @param tenantId - Tenant ID
 * @param query - Optional query parameters (search, limit)
 */
export const useDocumentDatabases = (tenantId: string, query?: DocumentDatabaseListQuery) => {
  return useQuery({
    queryKey: ['documentDatabases', tenantId, query],
    queryFn: async () => {
      const result = await documentDatabaseService.listDocumentDatabases(tenantId, query);
      return result;
    },
    enabled: !!tenantId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
